import { render, staticRenderFns } from "./BannerIntegrations.vue?vue&type=template&id=4d658a5c&scoped=true&"
import script from "./BannerIntegrations.vue?vue&type=script&lang=js&"
export * from "./BannerIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./BannerIntegrations.vue?vue&type=style&index=0&id=4d658a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d658a5c",
  null
  
)

export default component.exports